import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';

const IconTab = styled(Icon)`
  display: none;
  ${mediaqueries.greaterThan('mobile')`
    display: initial;
    margin: -.2rem ${rem('5px')} 0 0;
  `};
`;

const Tab = styled.li.attrs({
  'aria-selected': props => props.active
})`
  align-items: center;
  border-bottom: ${rem('3px')} solid ${props => props.theme.colors.light};
  cursor: pointer;
  display: inline-flex;
  flex: 100%;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  justify-content: center;
  padding: ${rem('9px')} 1rem ${rem('5px')} 1rem;
  text-transform: uppercase;
  white-space: nowrap;

  &:before {
    content: none;
  }

  &:last-child {
    margin-right: 0;
  }

  ${props =>
    props.active &&
    css`
      border-color: ${props.theme.colors.grayDark};
      cursor: default;
    `};

  ${mediaqueries.greaterThan('mobile')`
    background-color: ${props => props.theme.colors.grayLighter};
    border-color: ${props => props.theme.colors.grayLight};
    margin-right:${rem('5px')};
    padding: ${rem('6px')} 1rem ${rem('2px')} 1rem;
    

    ${props =>
      props.active &&
      `
        background-color: ${props.theme.colors.dark};
        border-color: ${props.theme.colors.dark};
        color: ${props.theme.colors.light};
      `};

    `};
  ${mediaqueries.greaterThan('desktop')`
    ${props =>
      props.from &&
      props.from === 'search' &&
      css`
        width: ${rem('235px')};
      `}
    &:hover {
      background-color: ${props => props.theme.colors.graySad};
      color: white;
      ${IconTab}{
        fill: ${props => props.theme.colors.light};             
        stroke: ${props => props.theme.colors.light};
        pointer-events:all;
      }
    }
  `};
`;

const TabWithButton = Tab.extend`
  border-color: ${props => props.theme.colors.dark};
  color: ${props => props.theme.colors.light};
  min-width: 100%;

  ${mediaqueries.greaterThan('mobile')`
    color: ${props => props.theme.colors.dark};
    min-width: 0;
    
    ${props =>
      props.active &&
      `
        color: ${props.theme.colors.light};
      `};
  `};
`;

export { Tab, TabWithButton, IconTab };
